import * as React from 'react';
import { SVGProps } from 'react';

const FileIconAviSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 12v13H5V12h14Zm-3 12h2v-2h-2v2Zm0-3h2v-2h-2v2Zm-1-2v5.056H9V19h6Zm0-1H9v-5.056h6V18Zm1 0h2v-2h-2v2Zm0-3h2v-2h-2v2Zm-8 1v2H6v-2h2Zm-2 5v-2h2v2H6Zm0 1v2h2v-2H6Zm2-7v-2H6v2h2Z"
      fill="#fff"
    />
    <path d="M17 3V2h-1v1h1ZM15 4v1h1v3h-1v1h3V8h-1V4h-2Z" fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.95 9a.659.659 0 0 1-.29-.08.818.818 0 0 1-.26-.22.73.73 0 0 1-.61.3H7.45c-.507 0-.877-.1-1.11-.3C6.113 8.493 6 8.143 6 7.65v-.1C6 6.517 6.487 6 7.46 6H9v-.35c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17H6.5V4h1.8c.58 0 1.007.127 1.28.38.28.253.42.66.42 1.22V8c0 .1.037.177.11.23.08.047.21.07.39.07V9h-.55ZM8.54 8c.2 0 .327-.047.38-.14A.72.72 0 0 0 9 7.5V7H7.6a.583.583 0 0 0-.599.554c.008.146.048.255.119.326.08.08.207.12.38.12h1.04Z"
      fill="#fff"
    />
    <path d="M12 4h-1v3l1 2h1l1-2V4h-1v3h-1V4Z" fill="#fff" />
  </svg>
);
export default FileIconAviSizeS;
